import DynamicSelector from "components/Molecules/DynamicSelector"
import SearchFilter, {
  SearchFilterCallout,
} from "components/Organisms/SearchFilter"
import { DEPOTS, DISTRIBUTION_CENTERS } from "graphql/selector.queries.gql"
import React from "react"
import { useFilter } from "store/search-filter/search-filter.reducer"

const DockFilter = () => {
  const [filter, setFilter] = useFilter("docks")

  return (
    <SearchFilter
      className="ml-3"
      value={filter}
      getValues={values => {
        setFilter(values)
      }}
      onClear={() => setFilter({})}
    >
      <SearchFilterCallout title="Distribution Center">
        <DynamicSelector
          fill
          className="mb-0 w-full"
          query={DISTRIBUTION_CENTERS}
          path="distributionCentre"
        />
      </SearchFilterCallout>
      <SearchFilterCallout title="Depot">
        <DynamicSelector
          fill
          className="mb-0 w-full"
          query={DEPOTS}
          path="depot"
        />
      </SearchFilterCallout>
    </SearchFilter>
  )
}

export default DockFilter
